import React,{useState} from 'react';
import {
  Button,
  Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
// import SettingTab from './action-tab/fruit-profile-settings';
import { useHarvestingContext } from 'src/views/harvesting/harvesting-context';
import {OfflineFishingReportDialog} from './offline-fishing-report';
const useStyles = makeStyles((theme) => ({
  buttonSet: {
    display:'flex',
    '& > button:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
    '& .MuiButtonBase-root': {
      backgroundColor: 'white',
      border: '#aaa',
    },
  },
}));

interface SettingBarType {
    setShareIsLove:(arg0: boolean)=>void
}
export const SettingBar:React.FC<SettingBarType> = ({setShareIsLove})=>{
  const classes = useStyles();
  const {resetBaskets} = useHarvestingContext();
  const [dialogOpen, setDialogOpen]=useState(false);

  return (
    <Box className={classes.buttonSet}>
      <Button
        color="secondary"
        variant="outlined"
        onClick={() => resetBaskets()}
      >
          Reset
      </Button>
      <Button
        color="secondary"
        variant="outlined"

        onClick={() => setShareIsLove(true)}
      >
          Share
      </Button>
      <Button
        color="primary"
        variant="outlined"
        onClick={()=>setDialogOpen(true)}
        style={{marginLeft:'auto'}}
      >
                Report Offline fishing
      </Button>
      {dialogOpen&&(
        <OfflineFishingReportDialog
          dialogOpen={dialogOpen}
          closeDialog={()=>setDialogOpen(false)}
        />
      )}
     
    </Box>
  );
};


